<app-visionnaire-loader class="ipe:w-full" />
